import { render, staticRenderFns } from "./overviewPanel.vue?vue&type=template&id=b3126de6&"
import script from "./overviewPanel.vue?vue&type=script&lang=js&"
export * from "./overviewPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports